<template>
  <div>
    <p class="display-2 text-center font-weight-bold indigo--text">Mission Statement</p>
    <blockquote
      class="headline blockquote"
    >We are living in a multicultural, multilingual era, creating new spaces for hybridity that unsettle cultural binaries of the past. We believe it is important to complicate the dichotomous idea of here and there-ness that has dominated historical narratives. We aim to create a publication that looks to address themes such as migration, diaspora, in-betweenness, identity, cultural diversity, and language.</blockquote>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
      alignment: "center",
      dense: false,
      justifyAvailable: [
        "start",
        "center",
        "end",
        "space-around",
        "space-between"
      ],
      justify: "center"
    };
  }
};
</script>
